import React from 'react';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import ActionBarButton from '../../_partials/ActionBarButton';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import PremiumIcon from '../../../Icons/Premium';
import ActionBarItemWrapper from '../../_partials/ActionBarButton/ActionBarItemWrapper';
import ActionBarLink from '../../_partials/ActionBarButton/ActionBarLink';
var PcpDownloadLink = function (_a) {
    var deviation = _a.deviation, onDownload = _a.onDownload, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, iconRef = _a.iconRef;
    var isActionBarButtonRefactorFlagEnabled = useFlag('actionbar_button_refactor');
    var t = useTranslation().t;
    return isActionBarButtonRefactorFlagEnabled ? (React.createElement(ActionBarItemWrapper, { tooltip: t('actionbar.pcp.owned') },
        React.createElement(ActionBarLink, { href: get(deviation, 'extended.pcp.url'), target: "_blank", download: true, onClick: onDownload, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, biData: {
                evid: BiEventType.CLICK_DOWNLOAD_BUTTON,
                deviationid: deviation.deviationId,
                ispaiddownload: 1,
            } },
            React.createElement(ActionBarIcon, { icon: PremiumIcon, iconRef: iconRef })))) : (React.createElement(ActionBarButton, { href: get(deviation, 'extended.pcp.url'), target: "_blank", onClick: onDownload, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, isDownload: true, tooltip: t('actionbar.pcp.owned'), biData: {
            evid: BiEventType.CLICK_DOWNLOAD_BUTTON,
            deviationid: deviation.deviationId,
            ispaiddownload: 1,
        } },
        React.createElement(ActionBarIcon, { icon: PremiumIcon, iconRef: iconRef })));
};
PcpDownloadLink.displayName = 'PcpDownloadLink';
export default PcpDownloadLink;
//# sourceMappingURL=PcpDownloadLink.js.map